module.exports = __webpack_public_path__ + "img/equity_icon2.9d5dca7a.png";